import {combineReducers} from 'redux';
import AppReducer from './app/reducer';
import FormsReducer from './forms/reducer';
import LocaleReducer from './locale/reducer';
import ThemeReducer from './theme/reducer';
import UserReducer from './user/reducer';
import RoutesReducer from './routes/reducer';
import NotificationsReducer from './notifications/reducer';
import NavigationReducer from './navigation/reducer';
import ModelConfigReducer from './model-configs/reducer';
import OrderProductFilesReducer from './order-product-files/reducer';
import ServicesReducer from './services/reducer';
import FeaturesReducer from './features/reducer';
import {reducer as WorkdayReducer} from './workday';
import {reducer as ChatsReducer} from './chats';
import {reducer as ArticlesReducer} from './articles';

const reducers = combineReducers({
    app: AppReducer,
    forms: FormsReducer,
    locale: LocaleReducer,
    theme: ThemeReducer,
    user: UserReducer,
    routes: RoutesReducer,
    notifications: NotificationsReducer,
    navigation: NavigationReducer,
    modelConfigs: ModelConfigReducer,
    orderProductFiles: OrderProductFilesReducer,
    services: ServicesReducer,
    features: FeaturesReducer,
    workday: WorkdayReducer,
    chats: ChatsReducer,
    articles: ArticlesReducer,
});

export default reducers;
